import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DisputeService } from '@app/_services/dispute.service';
import { first } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { verificationDoc } from '@app/_models/verificationDoc';
import { raiseDispute } from '@app/_models/raiseDispute';
import { LogService } from '../../_shared/log.service';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-verification-list-dispute',
  templateUrl: './verification-list-dispute.component.html',
  styleUrls: ['./verification-list-dispute.component.css']
})
export class VerificationListDisputeComponent implements OnInit {
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  DisputeDataForm: FormGroup;
  submitted = false;
  // rdbBtn:any;
  disputeForm: FormGroup;
  request: verificationDoc[];
  requestTable: verificationDoc[];
  dtTrigger1: Subject<any> = new Subject<any>();
  title = 'Dispute';
  dtOptions: DataTables.Settings = {};
  user_email;
  user_phone_no;
  user_contact_name;
  appId;
  pid;
  raiseDispute = new raiseDispute();
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('showErrorModalBox', { read: TemplateRef }) showErrorModalBoxTemplate: TemplateRef<any>;
  messageStr: string;
  @ViewChild('closebuttonRemark') closebuttonRemark;

  get f() { return this.DisputeDataForm.controls; }


  constructor(private disputeService: DisputeService,
    private formBuilder: FormBuilder,
    public fb: FormBuilder,
    private eventService: LogService,
    private modalService: NgbModal,
    config: NgbModalConfig,
    private SpinnerService: NgxSpinnerService
    , public datepipe: DatePipe,
    private verifyDocService: VerifyDocumentService) {

    this.disputeForm = this.fb.group({
      application_id: [''],
      phoneNumber: [''],
      email: [''],
      reason: [''],

    })

  }

  //only number will be add
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  ngOnInit() {

    this.DisputeDataForm = this.formBuilder.group({
      email: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      reason: ['', Validators.required]
    });

    var userId = localStorage.getItem('user_id');
    this.disputeService.getVerifiedDocsByUserid(userId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.request = data.respData;
          console.log(this.request);
          this.dtTrigger1.next();
        },
        error => {
          console.log(error)

        },
      )
  }

  ngAfterViewInIt() {
    this.dtTrigger1.next();
  }

  downloadPDF(element) {
    this.verifyDocService.getPDF(element)
      .subscribe(
        (data: Blob) => {
          var file = new Blob([data], { type: 'application/pdf' })
          var fileURL = URL.createObjectURL(file);

          var currentDate = new Date()

          // this.date=new Date();
          let latest_date = this.datepipe.transform(currentDate, 'yyyy-MM-dd');

          // if you want to open PDF in new tab
          // window.open(fileURL); 
          var a = document.createElement('a');
          a.href = fileURL;
          a.target = element + '_' + latest_date;
          a.download = element + '_' + latest_date + '.pdf';
          document.body.appendChild(a);
          a.click();
        },
        (error) => {
          console.log('getPDF error: ', error);
        }
      );
  }


  getUserData() {
    this.raiseDispute.reason = '';
    // alert("appplication id" + this.appId);
    // if (this.appId == undefined) {
    //   this.modalService.open(this.pleaseSelectBoxTemplate);
    //   return;
    // }   


    var user_ID = localStorage.getItem('user_id');
    this.disputeService.getUserInfoOnLode(user_ID)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          $("#phoneNumber").val(data.respData.phone_no);
          $("#email").val(data.respData.email);
          this.user_contact_name = data.respData.name;
          this.user_email = data.respData.email;
          this.user_phone_no = data.respData.phone_no;
          // this.request = data.respData;
          // console.log(this.request);
        },
        error => {
          console.log(error)
        },
      )
  }

  getApplicationId(appId, id) {
    console.log("here--->", 1, appId, id)
    this.appId = appId;
    this.pid = id;
  }

  submitDispute() {

    this.raiseDispute.application_id = this.appId;
    this.raiseDispute.id = this.pid;

    if (this.raiseDispute.contact_person_name == undefined) {
      this.raiseDispute.contact_person_name = this.user_contact_name;
    }
    if (this.raiseDispute.email == undefined) {
      this.raiseDispute.email = this.user_email;
    }
    if (this.raiseDispute.phone_no == undefined) {
      this.raiseDispute.phone_no = this.user_phone_no;
    }

    this.submitted = true;

    // if (this.DisputeDataForm.invalid) {

    //   return;
    // }

    if (this.raiseDispute.email == null && this.raiseDispute.email == null && this.DisputeDataForm.controls.reason.invalid) {

      return;
    }
    if (this.raiseDispute.email != null && this.raiseDispute.email != null && this.DisputeDataForm.controls.reason.invalid) {

      return;
    }


    console.log(this.raiseDispute)
    this.disputeService.saveDispute(this.raiseDispute)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.SpinnerService.hide();
          if (data.respData == true) {
            this.modalService.open(this.showModalBoxTemplate);
          }
          if (data.respData == false) {
            this.modalService.open(this.showErrorModalBoxTemplate);
            this.messageStr = 'Failure: Dispute has already been raised against this record.';
            //alert('Failure: Dispute has already been raised against this record.')
          }
        },
        error => {
          this.closebuttonRemark.nativeElement.click();
          this.modalService.dismissAll(this.showModalBoxTemplate);
          this.eventService.emit<string>("0")
          this.SpinnerService.hide();
          console.log(error)
        }
      )
    this.SpinnerService.show();
  }

  refresh(): void {
    this.closebuttonRemark.nativeElement.click();
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>("0")
  }
}
